<template>
  <div>
    <base-loader v-if="tNumbers === null"></base-loader>
    <div v-else-if="tNumbers.length > 0" class="d-flex flex-column" style="gap: 8px;">
      <div v-for="(item, index) in tNumbers" :key="index" class="d-flex align-items-start mb-1" style="gap: 8px;">
        <div>
          <a :href="item.U_LabelLink" target="_blank" class="pdf-button" v-tooltip.left="{value: 'PDF'}">
            <i class="fa fa-file-pdf"></i>
          </a>
          <a v-if="item.U_Carrier == 'PAQUETEXPRESS'" :href="item.U_LabelLink.replace('4x6', '7x4.75')" target="_blank" class="pdf-button" v-tooltip.left="{value: '7x4.75'}">
            <i class="fa fa-file-pdf"></i>
          </a>
        </div>
        <div style="flex:1; min-width: 0;" >
          <div class="text-xs d-flex align-items-center justify-content-between mb-1" style="height: 24px;">
            {{carriers.find(x => x.id === item.U_Carrier).name}}
            <badge type="info">{{ item.U_LastEventDesc }}</badge>
          </div>
        <div class="tracking-container"          
          v-tooltip.right="{value: 'Copiar'}"
          @click="copyToClipboard(item.U_TrackingId, index)"
        >
        <div class="text-xs font-weight-bold" style="letter-spacing: 2px;overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
          {{ item.U_TrackingId }}
        </div>
        <i class="fa fa-clone fa-lg icon-copy" :class="{'copied': copied === index}" ></i>
        </div>
        </div>
      </div>
    </div>
    <empty-section v-else-if="showEmpty" class="my-3" size="sm"></empty-section>
  </div>
</template>

<script>
import axios from 'axios'
import BaseLoader from '@/components/BaseLoader.vue'
import EmptySection from '@/components/EmptySection.vue'
import Tooltip from "primevue/tooltip";
import Vue from "vue";
import carriers from "@/data/carriers.json";
Vue.directive("tooltip", Tooltip);
  export default {
    name: 'TrackingNumbers',
    directives: {
      Tooltip,
    },
    components: {
      BaseLoader,
      EmptySection
    },
    props: {
      docNum: {
        type: Number,
        required: true
      },
      docType: {
        type: String,
        required: true
      },
      showEmpty: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        tNumbers: null,
        carriers: carriers,
        copied: null,
      }
    },
    methods: {
      getTrackingNumbers(){
        this.tNumbers = null
        axios.get(`api/trkd/by/document?DocType=${this.docType}&DocNum=${this.docNum}`)
          .then(res => {
            this.tNumbers = res.data.reduce((acc, currentObj) => {
              const splitCode = currentObj.Code.split('-')[0];
              let repeated = acc.find(x => x.Code.split('-')[0] === splitCode);
              if(!repeated){
                acc.push(currentObj);
              }
              return acc;
            }, []);
          })
          .catch(e => {
            console.error('There was an error!', e)
          })
      },
      copyToClipboard(text, index) {
        navigator.clipboard.writeText(text);
        this.copied = index;
        setTimeout(() => {
          this.copied = null;
        }, 1200);
      },
    },
    created() {
      this.getTrackingNumbers()
    },
  }
</script>

<style lang="scss" scoped>
.tracking-container {
  background: #f6f9fc;
  padding: 4px 8px;
  border-radius: 0.375rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  cursor: pointer;
  width: 100%;
}
.tracking-container:hover{
  background-color: #e9eef3;
}
.tracking-container:hover .icon-copy{
  color: #8898aa;
}
.icon-copy {
  color: #ced4da;
  font-size: 14px;
  cursor: pointer;
  transition: all 200ms ease-in-out;
}
.pdf-button {
  background-color: white;
  height: 24px;
  width: 24px;
  border-radius: 0.375rem;
  color: #f5365c;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pdf-button:hover {
  background-color: #fee2e2;
}
.icon-copy.copied {
  color: #5e72e4 !important;
}
</style>
<style>
.p-tooltip .p-tooltip-text {
  padding: 2px 6px;
  font-size: 11px;
}
</style>